<template>
  <b-modal
    ref="modal"
    title="Upload"
    size="lg"
    @ok="ok"
    @hide="closeHandler"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <Vue2Dropzone
      id="uploadDropzone"
      ref="fileInput"
      :options="dropzoneOptions"
      @vdropzone-file-added="setFiles"
      @vdropzone-removed-file="setFiles"
    />
  </b-modal>
</template>


<script>
import modalMixin from './mixin'
import Vue2Dropzone from "vue2-dropzone";
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "UploadModal",
  components: {
    Vue2Dropzone,
  },
  mixins: [
    modalMixin
  ],
  data: () => ({
    files: [],
    dropzoneOptions: {
      url: 'http',
      autoProcessQueue: false,
      addRemoveLinks: true,
      createImageThumbnails: false,
      dictDefaultMessage: 'Drag & Drop your files or <a href="#" onclick="event.preventDefault()">Browse</a>',
      maxFilesize: 1000,
    },
  }),
  methods: {
    ...mapActions(['uploadFiles']),
    ok () {
      this.uploadFiles({
        files: this.files,
      })
    },
    setFiles () {
      this.$nextTick(() => {
        this.files = this.$refs.fileInput ? this.$refs.fileInput.getAcceptedFiles() : []
      })
    },
    onModalShown() {
      this.$root.$emit('upload-modal-shown');
    },
    onModalHidden() {
      this.$root.$emit('upload-modal-hidden');
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep #uploadDropzone .dz-progress {
  display: none;
}

::v-deep .dz-preview .dz-image > img {
  width: 100%;
  max-height: 300px;
}
</style>